import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=1af6edce"
import script from "./send-message.vue?vue&type=script&lang=js"
export * from "./send-message.vue?vue&type=script&lang=js"
import style0 from "./send-message.vue?vue&type=style&index=0&id=1af6edce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports